import React, { useMemo } from 'react';
import { MdArrowDropDownCircle } from 'react-icons/md';
import { FaRegCalendar } from 'react-icons/fa';
import { DropDown } from '~/components';
import SubHeader from '~/pages/templates/SubHeader';
import { asyncState } from '~/hooks';
import { useDashboard } from './context';
//import { json } from 'jest.config';



const Header = () => {
    const { timespan, setTimespan, policyMetrics, titleMetrics, girdTimeSpan, setGirdTimeSpan } = useDashboard();

    return (
        <SubHeader 
            title='Your Recent Activity'
            subtitle={() => <TimespanSwitch timespan={girdTimeSpan} updateTimespan={setGirdTimeSpan}/>}
            content={() => {
                return (
                    <div className='grid grid-cols-6 w-6/6 ml-auto gap-2' >
                        <div className='m-auto'><TimespanSwitch timespan={timespan} updateTimespan={setTimespan} /></div>
                        {policyMetrics.status == asyncState.SUCCESS && (<PolicyMetrics data={policyMetrics.value}/>)} 
                        {titleMetrics.status == asyncState.SUCCESS && (<TitleMetrics data={titleMetrics.value}/>)} 
                    </div>
                );
            }} />
    );
};

export default Header;

const timespanText = Object.freeze({
    [1]: 'today',
    [7]: 'the last 7 days',
    [30]: 'the last 30 days',
    [365]: 'the last year',
    [0]: 'all time'
});

function TimespanSwitch({timespan, updateTimespan}) {
    const text = `For ${timespanText[timespan]}`;

    return (
        <div className='flex flex-col items-start justify-between w-1/2' style={{ minWidth: 'fit-content' }}>
            <p className='text-sm font-bold text-neutral-80 mr-2'>{text}</p>
            <DropDown 
                text='Switch' 
                wrapperClass="bg-white left-0 rounded-md shadow-md"
                icon={MdArrowDropDownCircle}
                iconSize='1.375em'
                iconClass='ml-1'
                buttonClass='py-1 text-blue-50 font-semibold text-sm focus:outline-none flex items-center justify-center'>
                <div className="flex flex-col items-stretch w-40 text-neutral-80 text-sm">
                    <p className="font-semibold p-4 py-2">Switch View</p>
                    <button 
                        className="py-2 px-4 hover:bg-blue-10 focus:outline-none flex items-center"
                        onClick={() => updateTimespan(365)}>
                        <CalendarIcon>365</CalendarIcon>
                        <span className="ml-2 pt-1">Last Year</span>
                    </button>
                    <button 
                        className="py-2 px-4 hover:bg-blue-10 focus:outline-none flex items-center"
                        onClick={() => updateTimespan(30)}>
                        <CalendarIcon>30</CalendarIcon>
                        {/* <span className='text-xs tracking-tighter font-medium'>30</span> */}
                        <span className="ml-2 pt-1 ">Last 30 Days</span>
                    </button>
                    <button 
                        className="py-2 px-4 hover:bg-blue-10 focus:outline-none flex items-center"
                        onClick={() => updateTimespan(7)}>
                        <CalendarIcon>7</CalendarIcon>
                        <span className="ml-2 pt-1 ">Last 7 Days</span>
                    </button>
                    <button 
                        className="py-2 px-4 hover:bg-blue-10 focus:outline-none flex items-center"
                        onClick={() => updateTimespan(1)}>
                        <CalendarIcon>1</CalendarIcon>
                        <span className="ml-2 pt-1 ">Today</span>
                    </button>
                    <button 
                        className="py-2 px-4 border-t hover:bg-blue-10 focus:outline-none flex items-center"
                        onClick={() => updateTimespan(0)}>
                        <CalendarIcon>All</CalendarIcon>
                        <span className="ml-2 pt-1 pb-1 ">All Time</span>
                    </button>
                </div>
            </DropDown>
        </div>
    );
}

function CalendarIcon ({children}) {
    return (
        <span className='relative h-4 w-4 mr-1 mb-2 mt-1 text-neutral-80'>
            <FaRegCalendar 
                className='absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2'
                size='1.825em'/>
            <span className='z-10 text-xs font-medium tracking-tighter absolute top-3/4 left-1/2 transform -translate-y-1/2 -translate-x-1/2 scale-75'>
                {children}
            </span>
        </span>
    );
}

function PolicyMetrics({data}) {
    //console.log("Preston" + JSON.stringify(data)) ;
    const _data = useMemo(
        () => Object.assign({ found: 0, total: 0}, data.requested), 
        [data]);

    return (
        <>
            <Metric label='Prior Policy Requests' value={_data.total}/>
            <Metric label='Prior Policies Found' value={_data.found}/>
        </>
    );
}
function TitleMetrics({data}) {
    const _data = useMemo(
        () => Object.assign({ ptoSubmitted: 0, ftoSubmitted: 0, stfoSubmitted: 0}, data), 
        [data]);

    return (
        <>
            <Metric label={<>PTO<br/>Submitted</>} value={_data.ptoSubmitted}/>
            <Metric label={<>FTO<br/>Submitted</>} value={_data.ftoSubmitted}/>
            <Metric label={<>STF<br/>Submitted</>} value={_data.stfoSubmitted}/>
        </>
    );
}

function Metric ({label, value}) {
    return (
        <div className='flex flex-col justify-center h-full w-full'>
            <span className='h-10'>
                <p className='text-xs font-medium text-neutral-80 uppercase'>{label}</p>
            </span>
            <span className='text-2xl tracking-tight font-semibold text-blue-50'>{value}</span>
        </div>
    );
}